import { render, staticRenderFns } from "./StoreRankingTable.vue?vue&type=template&id=43587e68&"
import script from "./StoreRankingTable.vue?vue&type=script&lang=js&"
export * from "./StoreRankingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports